// Reads a field off a map pin, falling back to the untouched Supabase row
// carried as _raw. Means a new DB column is readable everywhere the pins go —
// list view, filters, property page — without extending the pin builder.
//
// Treats "" as absent as well as null/undefined, because the CoStar import
// leaves empty strings in place of missing values.
export function pinField(pin, key) {
  if (!pin) return null;
  const direct = pin[key];
  if (direct !== undefined && direct !== null && direct !== "") return direct;
  const raw = pin._raw;
  if (raw && raw[key] !== undefined && raw[key] !== null && raw[key] !== "") return raw[key];
  return null;
}

// First non-null value among several candidate keys. Used where the same idea
// lives under different column names per table — a comp's submarket is
// micro_market, a property's is submarket.
export function pinFieldAny(pin, keys) {
  for (const k of keys) {
    const v = pinField(pin, k);
    if (v !== null) return v;
  }
  return null;
}

export const asNumber = v =>
  (v == null || v === "" || isNaN(Number(v)) ? null : Number(v));
